import { Step, StepContainer, StepLabel } from './styles';

interface ProgressStepsProps {
    currentStep: number;
}

export const ProgressSteps = ({ currentStep }: ProgressStepsProps) => {
    const totalSteps = 6;

    return (
        <>
            <StepContainer>
                {Array.from({ length: totalSteps }, (_, i) => (
                    <Step key={i} isCompleted={i < currentStep} isActive={i === currentStep} />
                ))}
            </StepContainer>
            <StepLabel level={4}>{`Step ${currentStep + 1} of ${totalSteps}`}</StepLabel>
        </>
    );
};
